export function formatOrganizationRole(role) {
  const labels = {
    org_owner: 'Org Owner',
    org_admin: 'Org Admin',
    policy_admin: 'Policy Admin',
    viewer: 'Teacher / Limited Staff',
  };
  return labels[role] || role || 'Unknown role';
}
